// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleRubric_root__uEgHx","link":"ArticleRubric_link__2zvFo"};